import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { trigger } from '../helpers/customEventListener';
import useLdFlags from './useLdFlags';
import { FLAG_NAMES, ROUTES } from '@profile-ui-mono/utilities/constants';

const useAuthRegister = (authConfig) => {
  const auth = window.cfp.providers.auth;
  const [loggedIn, setLoggedIn] = useState(false);
  const navigate = useNavigate();
  const flags = useLdFlags();
  const loginPageEnabled = flags[FLAG_NAMES.LOGIN_PAGE_ENABLED];
  const handleLoginRedirect = async () => {
    if (loginPageEnabled) {
      navigate(ROUTES.LOGIN, { replace: true });
    } else {
      await auth.login();
    }
  };

  useEffect(() => {
    (async function login() {
      try {
        await auth.register(authConfig);
        // possible flow: 
        // 1. user is not logged in, visit login page
        // 2. user is registered
        // 3. user logs in
        // 4. since all logged in pages use this hook, user gets already been registered error
        // 5. without handling the error, user is redirected to login page
      } catch (e) {
        // If you don’t catch already been registered error within useAuthRegister, if user is authenticated, and you try to visit the login page, instead of getting redirected, you get stuck on the login page with a continuous already been registered error.
        if (!(e.message && e.message.includes('already been registered'))) {
          trigger('USER_SIGNING_OUT');
          await handleLoginRedirect();
          return; // Exit early after handling register error
        }
      }
      try {
        const isLoggedInResult = await auth.isLoggedIn();
        setLoggedIn(isLoggedInResult);
        if (!isLoggedInResult) {
          handleLoginRedirect();
        }
      } catch (e) {
        trigger('USER_SIGNING_OUT');
        await handleLoginRedirect();
      }
    })();
  }, [loginPageEnabled]);

  return loggedIn;
};
export default useAuthRegister;
